import { useQueryClient, useMutation } from 'react-query';
import { toast } from 'react-toastify';
import restFactory from 'v2/utils/restFactory';
import { infiniteUserInvitesKeys } from './query-keys';

async function deleteUserInvite(id: number) {
  return await restFactory.delete(`/dj/api/v1/invite_user/${id}/`);
}

export function useDeleteUserInvite() {
  const queryClient = useQueryClient();

  return useMutation(deleteUserInvite, {
    onSuccess: async () => {
      await queryClient.invalidateQueries(infiniteUserInvitesKeys.all);
      toast.success('Invitation was deleted successfully.');
    },
    onError: () => {
      toast.error('Failed to delete invitation.');
    },
  });
}
